import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import './InputNumber.scss';

type Props = {
  min?: number;
  value?: number;
  onChange: (value: number) => void;
};

function InputNumber({ min = 0, value = 0, onChange }: Props) {
  return (
    <div className='input-number'>
      <div className='input-number-wrapper'>
        <span
          className='decrement'
          onClick={() => {
            if (value <= min) return;
            onChange(value - 1);
          }}
        >
          <MinusOutlined />
        </span>
        <input
          type='number'
          className='input'
          onChange={(e) => {
            if (new RegExp(/^\d+$/).test(e.target.value)) {
              onChange(Number(e.target.value));
            } else return;
          }}
          value={value}
        />
        <span className='increment' onClick={() => onChange(value + 1)}>
          <PlusOutlined />
        </span>
      </div>
    </div>
  );
}

export default InputNumber;
